/* eslint-disable @typescript-eslint/no-extra-semi */
import { useCallback, useContext, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import baseAPI, { TokenResultView } from '../api';
import { deleteUserData, setUserData } from '../utils/user';

interface HookReturnType {
  user: TokenResultView | null;
  isLogging: boolean;
  doLogin: (email: string, otp: string) => Promise<TokenResultView>;
  doOtpLogin: (email: string, session: string, challengeName: string, otp: string) => Promise<TokenResultView>;
  doLogout: () => void;
}

function useAuthentication(): HookReturnType {
  const { user, setUser } = useContext(AuthContext);
  const [isLogging, setIsLogging] = useState<boolean>(false);

  const doLogin = useCallback(
    (email: string, otp: string) => {
      setIsLogging(true);
      return baseAPI.login
        .login({
          emailAddress: email,
          token: otp,
        })
        .then((res) => {
          setUserData(res.data);
          setUser(res.data);

          return res.data;
        })
        .finally(() => {
          setIsLogging(false);
        });
    },
    [setUser]
  );

  const doOtpLogin = useCallback(
    (email: string, session: string, challengeName: string, otp: string) => {
      setIsLogging(true);
      return baseAPI.login
        .otpAnswer({
          emailAddress: email,
          session: session,
          challengeName: challengeName,
          challengeAnswer: otp,
        })
        .then((res) => {
          setUserData(res.data);
          setUser(res.data);

          return res.data;
        })
        .finally(() => {
          setIsLogging(false);
        });
    },
    [setUser]
  );

  const doLogout = useCallback(() => {
    deleteUserData();
    setUser(null);
  }, [setUser]);

  return { user, isLogging, doLogin, doOtpLogin, doLogout };
}

export default useAuthentication;
